import { render } from "./ModalLogout.vue?vue&type=template&id=5a835526&scoped=true&ts=true"
import script from "./ModalLogout.vue?vue&type=script&lang=ts"
export * from "./ModalLogout.vue?vue&type=script&lang=ts"

import "./ModalLogout.vue?vue&type=style&index=0&id=5a835526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a835526"]])

export default __exports__